export default __webpack_public_path__ + "static/media/overviewBannerDesktop.65d43d27.png";